/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgDate = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M7 2v2H2v18h20V4h-5V2h-2v2H9V2H7zM4 6h3v2h2V6h6v2h2V6h3v14H4V6zm7.747 5.64V18h1.884V9.396H12.3l-2.544 1.812v1.104l1.992-.672z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgDate as Date };
